export default "__VITE_ASSET__rkLUy03X__"